import { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@ccm-office/ccm-ui';
import { useInterceptor } from './useInterceptor';
import { useHistory } from 'react-router-dom';

const ErrorHandlerDialog: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const [open, setOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const authError = useRef(false);

  const handleClose = useCallback(() => {
    setOpen(false);
    if (authError.current) {
      history.push('/');
      authError.current = false;
    }
  }, [history]);

  const errorResponseHandler = useCallback((error) => {
    if(error.dismissDialog){
      return Promise.reject(error);
    }
    if (error.message && !error.isLoginPage) {
      setMessage(error.message);
      setOpen(true);
      if (error.authError) {
        authError.current = true;
      }
    }
    return Promise.reject(error);
  }, []);

  useInterceptor(errorResponseHandler);

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      message={message || t('message.somethingWentWrong')}
      title={t('error.errorFromServer')}
      variant={'error'}
      closeLabel={t('button.ok')}
      handleCancel={handleClose}
    />
  );
};

export default ErrorHandlerDialog;
